<!--
Created on 2021-04-14
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-14
-->
<template>
  <div id="menu-confirm" class="menu menu-box-modal bg-red-dark rounded-m" 
      data-menu-width="310">
    <h1 class="text-center mt-3 pt-1"><i class="fa fa-3x fa-times-circle color-white shadow-xl rounded-circle"></i></h1>
    <h1 class="text-center mt-3 color-white font-700">{{ title }}</h1>
    <p v-if="message" class="boxed-text-l color-white opacity-70 mb-0">
      {{ message }}
    </p>
    <p v-if="messageHtml" class="boxed-text-l color-white opacity-70 mb-0" v-html="messageHtml">
    </p>
    <div class="row full-width mb-0">
      <div class="col-6 p-4">
        <div @click="$emit('onConfirm')" class="col-6 btn close-menu btn-m button-s shadow-l mb-4 rounded-s text-uppercase font-900 bg-white color-red-dark" style="width: 100%; margin-bottom: 0 !important;">{{ btnTitle }}</div>
      </div>
      <div class="col-6 p-4">
        <div class="col-6 btn close-menu btn-m button-s shadow-l mb-4 rounded-s text-uppercase font-900 color-white" style="width: 100%; margin-bottom: 0 !important;">zrušiť</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    title: {
      type: String,
      default: 'Naozaj?'
    },
    btnTitle: {
      type: String,
      default: 'zmazať'
    },
    message: {
      type: String,
      default: ''
    },
    messageHtml: {
      type: String,
      default: ''
    }
  },
  setup() {
    
  },
}
</script>
